import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  focusNext (event){
    const input = event.target;
    const nextInput = input.nextElementSibling;

    if (input.value.length === 1 && nextInput) {
      nextInput.focus();
    }
  }
}
